import { render } from "./PopupGroupByDistance.vue?vue&type=template&id=0ffe8f2b"
import script from "./PopupGroupByDistance.vue?vue&type=script&lang=js"
export * from "./PopupGroupByDistance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__